import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { countryName } from '../streamingFormat';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface DimensionNameProps {
  dimension: 'store' | 'country';
  value: string;
}

/** A store name, or a country with its code chip (design c2: no map, a code chip). */
const DimensionNameComponent: React.FC<DimensionNameProps> = ({ dimension, value }) => {
  const intl = useIntl();
  if (dimension === 'store') {
    return <span>{value}</span>;
  }
  return (
    <>
      <span className={styles.cc}>{value.toUpperCase()}</span>
      <span>{countryName(intl, value)}</span>
    </>
  );
};

export const DimensionName = TypedMemo(DimensionNameComponent);
